import {defineMessages, FormattedMessage} from 'react-intl';
import {Banner, css, view} from '@sail/ui/deprecated';

const messages = defineMessages({
  connecting: {
    id: 'conversations_ui.chat.connectionNotice.connecting',
    description:
      'Notice shown to users when their chat conversation is still connecting.',
    defaultMessage: 'Please wait while we connect…',
  },
  reconnecting: {
    id: 'conversations_ui.chat.connectionNotice.reconnecting',
    description:
      'Notice shown to users when there is an issue with their chat conversation connection and we attempt to reconnect',
    defaultMessage:
      'We noticed a problem with your connection. Please wait while we try to reconnect…',
  },
});

type Props = {
  status: 'connecting' | 'reconnecting';
};

export function ConnectionNotice({status}: Props) {
  const message = messages[status];
  return (
    <view.div data-testid="connection-notice" css={{flexGrow: css.value('0')}}>
      <Banner
        type="caution"
        css={{borderRadius: 'medium'}}
        description={<FormattedMessage {...message} />}
      />
    </view.div>
  );
}
